import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export function NestedTableFlatModeMainCellUniDriver(
  base: UniDriver,
  _body: UniDriver,
) {
  const getWrapper = () => base.$('[data-hook="flat-mode-main-cell"]');

  return {
    ...baseUniDriverFactory(base),
    getTitle: () => getWrapper().$('[data-hook="title"]').text(),
    getBreadcrumbs: () => getWrapper().$('[data-hook="breadcrumbs"]'),
  };
}
